/**
 * DEV-1786 (эпик DEV-1781). i18n раздела «Лендинги» в «Администрировании».
 * Overlay-модуль: подмешивается deepMerge поверх базовых локалей.
 */
export const landingsMessages = {
  ru: {
    common: {
      navigation: {
        marketing: 'Маркетинг',
        landings: 'Лендинги',
      },
    },
    landings: {
      lead: "Площадки на vinprop.vn публикуются отсюда: адрес vinprop.vn/lp/{'{'}слаг{'}'}, индексацией и мета-тегами управляет карточка. Внешние живут на домене партнёра или застройщика — публиковать и настраивать SEO для них нельзя, но заявки и просмотры по ним считаются так же.",
      title: 'Лендинги',
      filters: {
        search: 'Поиск',
        searchPlaceholder: 'Название или адрес',
        kind: 'Тип',
        status: 'Статус',
        allKinds: 'Все типы',
        allStatuses: 'Все статусы',
      },
      kind: {
        native: 'На vinprop.vn',
        anonymous: 'Внешняя площадка',
      },
      status: {
        DRAFT: 'Черновик',
        PUBLISHED: 'Опубликован',
        UNPUBLISHED: 'Снят',
      },
      deploy: {
        PENDING: 'В очереди',
        RUNNING: 'Публикуется…',
        PUBLISHED: 'Выкачен',
        FAILED: 'Ошибка выкатки',
        UNKNOWN: 'Нет данных',
        pipeline: 'Пайплайн',
      },
      indexing: {
        open: 'В поиске',
        closed: 'Закрыт',
        unset: 'Не задано',
        hint: 'Открыт ли лендинг поисковым системам',
      },
      columns: {
        landing: 'Лендинг',
        kind: 'Тип',
        status: 'Статус',
        indexing: 'Индексация',
        traffic: 'Просмотры · заявки за {days} дн. ({range})',
        campaigns: 'Кампаний',
        updated: 'Обновлён',
      },
      trafficUnavailable: 'Статистика недоступна',
      empty: {
        title: 'Лендингов нет',
        description: 'Каталог площадок пуст или отфильтрован полностью.',
      },
      info: {
        edit: 'Изменить',
        title: 'Информация о площадке',
        lead: 'Название и описание видны только в CRM: сама страница от этого не меняется.',
        name: 'Название',
        nameHint: 'Пусто — название из реестра: «{registry}»',
        description: 'Описание',
        descriptionPlaceholder: 'Под какую кампанию площадка и что важно помнить',
        tooLong: 'Не длиннее {max} символов',
      },
      card: {
        tabs: {
          overview: 'Обзор',
          seo: 'SEO',
        },
        openPage: 'Открыть страницу',
        publication: 'Публикация',
        state: 'Состояние',
        publishedOn: 'Опубликован {date}',
        canonical: 'Канонический адрес',
        seoHint: 'Вкладка «SEO» задаёт мета-теги и канон — они уедут при следующей публикации.',
        indexing: {
          openInSitemap: 'Открыта, страница в карте сайта',
          openNoSitemap: 'Открыта, вне карты сайта',
          closed: 'Закрыта от поиска',
        },
        traffic: 'За {days} дней ({range})',
        events: 'Что делали на странице за тот же период',
        noViews:
          'Просмотров за период нет — конверсию не из чего считать. ' +
          'Заявка приходит с формы, просмотр — от маячка страницы: похоже, он на площадке не стоит.',
        leadsExceedViews: 'Заявок больше, чем просмотров: часть визитов маячок не зафиксировал.',
        openAnalytics: 'Динамика и источники этой площадки →',
        views: 'Просмотры',
        leads: 'Заявки',
        conversion: 'Конверсия',
        trafficHint: 'Считается по слагу площадки: просмотр шлёт страница, заявку — форма на ней.',
        campaigns: 'Кампании на площадку (за всё время)',
        campaignsEmpty: 'Кампаний на эту площадку пока нет.',
        notFound: 'Лендинг не найден',
      },
      actions: {
        publish: 'Опубликовать',
        unpublish: 'Снять с публикации',
        open: 'Открыть',
        refresh: 'Обновить',
      },
      external: {
        title: 'Публикация и SEO задаются на стороне владельца домена',
        description:
          'Страницу собирает и выкатывает пайплайн застройщика, поэтому кнопок «Опубликовать» и вкладки SEO здесь нет — иначе мы бы выложили чужой контент по адресу vinprop.vn. Просмотры и заявки считаются как у своих площадок: на странице стоит наш маячок со слагом {slug}.',
      },
      seo: {
        indexing: {
          title: 'Индексация',
          toggle: 'Открыть для поисковых систем',
          on: 'Включено: страница открыта поиску — meta robots = index, follow. Лендинг живёт на основном домене, своего robots.txt у него нет: общий файл домена мы не трогаем.',
          off: 'Выключено: страница остаётся доступной, но из выдачи её убирает meta robots = noindex, nofollow. Лендинг живёт на основном домене, своего robots.txt у него нет: общий файл домена мы не трогаем.',
          sitemap: 'Добавить в sitemap.xml основного сайта',
          sitemapHint:
            'Доступно только для открытых лендингов: закрытый в карте сайта — противоречие, за которое Search Console ругается.',
        },
        meta: {
          title: 'Мета-теги',
          seoTitle: 'Заголовок страницы (title)',
          seoDescription: 'Описание (description)',
          titleCounter: '{count} из 60 символов — влезет в выдачу целиком',
          titleCounterOver: '{count} символов — в выдаче обрежется примерно на 60',
          descriptionCounter: '{count} из 160 символов — поисковик покажет около 160',
          canonical: 'Канонический адрес',
          canonicalSelf: 'Свой адрес — {url}',
          canonicalExternal: 'Другая страница — указать адрес',
          canonicalUrl: 'Адрес канонической страницы',
          canonicalUrlError: 'Нужен полный адрес со схемой: https://…',
          canonicalHint:
            'Если тот же проект есть на основном сайте, канонической делают одну страницу — иначе они делят между собой один и тот же запрос.',
          image: 'Картинка для мессенджеров и соцсетей',
          imageHint: '1200 × 630, JPG или PNG — её показывают Telegram, WhatsApp и Facebook',
          imageUpload: 'Загрузить',
          imageReplace: 'Заменить',
          imageError: 'Картинку загрузить не удалось',
        },
        output: {
          title: 'Что уедет на прод',
          sitemapFile: 'sitemap.xml основного сайта',
          sitemapIn: 'адрес включён',
          sitemapOut: 'адрес не включён — лендинг закрыт от индексации',
          hint: 'Теги подставляются при публикации из настроек выше — руками в разметке лендинга их не правят, иначе настройка и прод разъедутся.',
        },
        preview: {
          title: 'Как это увидят в поиске',
          fallbackTitle: 'Заголовок из вёрстки лендинга',
          fallbackDescription: 'Описание из вёрстки лендинга',
          hint: 'Поисковик вправе показать свой текст, но берёт он его из этих полей.',
        },
        checks: {
          title: 'Проверки',
          titleOk: 'Заголовок {count} символов — в выдаче поместится целиком',
          titleLong: 'Заголовок {count} символов — в выдаче обрежется',
          titleEmpty: 'Заголовок не задан — на прод уедет тот, что в вёрстке',
          descriptionOk: 'Описание {count} символов',
          descriptionLong: 'Описание {count} символов — поисковик покажет около 160',
          descriptionEmpty: 'Описание не задано — на прод уедет то, что в вёрстке',
          complexCompeting:
            'Тот же проект открыт на основном сайте: {url}. Выберите, какая из двух страниц каноническая',
          complexAction: 'Сделать канонической страницу проекта',
          canonicalInvalid: 'Канонический адрес неполный: нужен адрес со схемой https://',
          closed:
            'Лендинг закрыт от индексации — настройки сохранятся, но в поиск страница не попадёт',
        },
        footer: 'Настройки применяются при следующей публикации.',
        save: 'Сохранить',
        cancel: 'Отменить',
      },
      publishModal: {
        publishTitle: 'Опубликовать лендинг',
        unpublishTitle: 'Снять с публикации',
        publishConfirm: 'Опубликовать',
        unpublishConfirm: 'Снять',
        cancel: 'Отмена',
        willDeploy: 'Что уедет на прод',
        robots: 'Мета robots',
        canonical: 'Канонический адрес',
        sitemap: 'Карта сайта',
        sitemapIn: 'адрес войдёт в общий sitemap.xml',
        sitemapOut: 'адрес не включён — лендинг закрыт от индексации',
        robotsFileNote:
          'robots.txt общий для домена и здесь не меняется: индексацию закрывает мета-тег.',
        closedWarning:
          'Лендинг закрыт от индексации: страница будет доступна по адресу, но из поиска её уберёт мета-тег.',
        seoEmptyWarning:
          'Заголовок и описание не заданы — на прод уедет то, что написано в вёрстке.',
        unpublishWarning: 'Файлы будут удалены из хранилища, адрес начнёт отдавать 404.',
      },
    },
  },
  en: {
    common: {
      navigation: {
        marketing: 'Marketing',
        landings: 'Landings',
      },
    },
    landings: {
      lead: "Landings on vinprop.vn are published from here: the address is vinprop.vn/lp/{'{'}slug{'}'}, indexing and meta tags are managed in the card. External ones live on a partner or developer domain — we cannot publish them or set their SEO, but their views and leads are counted the same way.",
      title: 'Landings',
      filters: {
        search: 'Search',
        searchPlaceholder: 'Name or address',
        kind: 'Type',
        status: 'Status',
        allKinds: 'All types',
        allStatuses: 'All statuses',
      },
      kind: {
        native: 'On vinprop.vn',
        anonymous: 'External site',
      },
      status: {
        DRAFT: 'Draft',
        PUBLISHED: 'Published',
        UNPUBLISHED: 'Unpublished',
      },
      deploy: {
        PENDING: 'Queued',
        RUNNING: 'Publishing…',
        PUBLISHED: 'Deployed',
        FAILED: 'Deploy failed',
        UNKNOWN: 'No data',
        pipeline: 'Pipeline',
      },
      indexing: {
        open: 'Indexed',
        closed: 'Closed',
        unset: 'Not set',
        hint: 'Whether the landing is open to search engines',
      },
      columns: {
        landing: 'Landing',
        kind: 'Type',
        status: 'Status',
        indexing: 'Indexing',
        traffic: 'Views · leads, {days}d ({range})',
        campaigns: 'Campaigns',
        updated: 'Updated',
      },
      trafficUnavailable: 'Statistics unavailable',
      empty: {
        title: 'No landings',
        description: 'The catalogue is empty or fully filtered out.',
      },
      info: {
        edit: 'Edit',
        title: 'Landing information',
        lead: 'The name and description are visible in the CRM only — the page itself is unaffected.',
        name: 'Name',
        nameHint: 'Empty means the registry name: “{registry}”',
        description: 'Description',
        descriptionPlaceholder: 'Which campaign this landing serves and what to keep in mind',
        tooLong: 'No longer than {max} characters',
      },
      card: {
        tabs: {
          overview: 'Overview',
          seo: 'SEO',
        },
        openPage: 'Open page',
        publication: 'Publication',
        state: 'State',
        publishedOn: 'Published on {date}',
        canonical: 'Canonical address',
        seoHint:
          'The “SEO” tab sets meta tags and the canonical — they ship with the next publish.',
        indexing: {
          openInSitemap: 'Open, listed in the sitemap',
          openNoSitemap: 'Open, not in the sitemap',
          closed: 'Closed to search',
        },
        traffic: 'Last {days} days ({range})',
        events: 'On-page activity over the same period',
        noViews:
          'No views in this period — there is nothing to divide by. ' +
          'A lead comes from the form, a view from the page beacon: it looks like the beacon is missing.',
        leadsExceedViews: 'More leads than views: some visits were not recorded by the beacon.',
        openAnalytics: 'Dynamics and sources for this page →',
        views: 'Views',
        leads: 'Leads',
        conversion: 'Conversion',
        trafficHint:
          'Counted by the landing slug: the page reports a view, the form on it reports a lead.',
        campaigns: 'Campaigns to this landing (all time)',
        campaignsEmpty: 'No campaigns lead here yet.',
        notFound: 'Landing not found',
      },
      actions: {
        publish: 'Publish',
        unpublish: 'Unpublish',
        open: 'Open',
        refresh: 'Refresh',
      },
      external: {
        title: 'Publishing and SEO are set by the domain owner',
        description:
          'The page is built and deployed by the developer’s pipeline, so there is no “Publish” button and no SEO tab here — otherwise we would be serving someone else’s content at vinprop.vn. Views and leads are counted as for our own landings: the page carries our beacon with the slug {slug}.',
      },
      seo: {
        indexing: {
          title: 'Indexing',
          toggle: 'Open to search engines',
          on: 'On: the page is open to search — meta robots = index, follow. The landing lives on the main domain and has no robots.txt of its own: the shared file is left alone.',
          off: 'Off: the page stays reachable, but meta robots = noindex, nofollow keeps it out of search. The landing lives on the main domain and has no robots.txt of its own: the shared file is left alone.',
          sitemap: 'Add to the main site sitemap.xml',
          sitemapHint:
            'Available for open landings only: a closed page in the sitemap is a contradiction Search Console complains about.',
        },
        meta: {
          title: 'Meta tags',
          seoTitle: 'Page title',
          seoDescription: 'Description',
          titleCounter: '{count} of 60 characters — fits the search result in full',
          titleCounterOver: '{count} characters — search will cut it around 60',
          descriptionCounter: '{count} of 160 characters — search shows about 160',
          canonical: 'Canonical URL',
          canonicalSelf: 'Own address — {url}',
          canonicalExternal: 'Another page — set the address',
          canonicalUrl: 'Canonical page address',
          canonicalUrlError: 'A full address is required: https://…',
          canonicalHint:
            'If the same project exists on the main site, exactly one page should be canonical — otherwise they split the same query between them.',
          image: 'Image for messengers and social networks',
          imageHint: '1200 × 630, JPG or PNG — shown by Telegram, WhatsApp and Facebook',
          imageUpload: 'Upload',
          imageReplace: 'Replace',
          imageError: 'The image could not be uploaded',
        },
        output: {
          title: 'What goes to production',
          sitemapFile: 'main site sitemap.xml',
          sitemapIn: 'the URL is included',
          sitemapOut: 'the URL is excluded — the landing is closed to indexing',
          hint: 'Tags are applied on publish from the settings above — they are not edited by hand in the landing markup, or the settings and production drift apart.',
        },
        preview: {
          title: 'How search will show it',
          fallbackTitle: 'Title from the landing markup',
          fallbackDescription: 'Description from the landing markup',
          hint: 'Search may show its own text, but it takes it from these fields.',
        },
        checks: {
          title: 'Checks',
          titleOk: 'Title is {count} characters — fits the search result in full',
          titleLong: 'Title is {count} characters — search will cut it',
          titleEmpty: 'Title is not set — the markup value goes to production',
          descriptionOk: 'Description is {count} characters',
          descriptionLong: 'Description is {count} characters — search shows about 160',
          descriptionEmpty: 'Description is not set — the markup value goes to production',
          complexCompeting:
            'The same project is open on the main site: {url}. Choose which of the two pages is canonical',
          complexAction: 'Make the project page canonical',
          canonicalInvalid: 'The canonical address is incomplete: use a full https:// address',
          closed:
            'The landing is closed to indexing — settings will be saved, but the page will not reach search',
        },
        footer: 'Settings are applied on the next publish.',
        save: 'Save',
        cancel: 'Cancel',
      },
      publishModal: {
        publishTitle: 'Publish landing',
        unpublishTitle: 'Unpublish landing',
        publishConfirm: 'Publish',
        unpublishConfirm: 'Unpublish',
        cancel: 'Cancel',
        willDeploy: 'What goes to production',
        robots: 'Robots meta',
        canonical: 'Canonical URL',
        sitemap: 'Sitemap',
        sitemapIn: 'the URL will be added to the shared sitemap.xml',
        sitemapOut: 'the URL is excluded — the landing is closed to indexing',
        robotsFileNote:
          'robots.txt is shared across the domain and is not changed here: indexing is controlled by the meta tag.',
        closedWarning:
          'The landing is closed to indexing: the page stays reachable, but the meta tag keeps it out of search.',
        seoEmptyWarning:
          'Title and description are not set — the markup values will go to production as they are.',
        unpublishWarning:
          'Files will be removed from storage and the URL will start returning 404.',
      },
    },
  },
  vn: {
    common: {
      navigation: {
        marketing: 'Tiếp thị',
        landings: 'Trang đích',
      },
    },
    landings: {
      lead: "Trang đích trên vinprop.vn được xuất bản từ đây: địa chỉ vinprop.vn/lp/{'{'}slug{'}'}, việc lập chỉ mục và thẻ meta do thẻ này quản lý. Trang bên ngoài nằm trên tên miền của đối tác hoặc chủ đầu tư — không thể xuất bản hay đặt SEO, nhưng lượt xem và yêu cầu vẫn được tính như nhau.",
      title: 'Trang đích',
      filters: {
        search: 'Tìm kiếm',
        searchPlaceholder: 'Tên hoặc địa chỉ',
        kind: 'Loại',
        status: 'Trạng thái',
        allKinds: 'Mọi loại',
        allStatuses: 'Mọi trạng thái',
      },
      kind: {
        native: 'Trên vinprop.vn',
        anonymous: 'Trang bên ngoài',
      },
      status: {
        DRAFT: 'Bản nháp',
        PUBLISHED: 'Đã xuất bản',
        UNPUBLISHED: 'Đã gỡ',
      },
      deploy: {
        PENDING: 'Đang chờ',
        RUNNING: 'Đang xuất bản…',
        PUBLISHED: 'Đã triển khai',
        FAILED: 'Triển khai lỗi',
        UNKNOWN: 'Không có dữ liệu',
        pipeline: 'Pipeline',
      },
      indexing: {
        open: 'Được lập chỉ mục',
        closed: 'Đã đóng',
        unset: 'Chưa đặt',
        hint: 'Trang đích có mở cho công cụ tìm kiếm hay không',
      },
      columns: {
        landing: 'Trang đích',
        kind: 'Loại',
        status: 'Trạng thái',
        indexing: 'Lập chỉ mục',
        traffic: 'Lượt xem · yêu cầu {days} ngày ({range})',
        campaigns: 'Chiến dịch',
        updated: 'Cập nhật',
      },
      trafficUnavailable: 'Không có thống kê',
      empty: {
        title: 'Chưa có trang đích',
        description: 'Danh mục trống hoặc đã bị lọc hết.',
      },
      info: {
        edit: 'Chỉnh sửa',
        title: 'Thông tin trang đích',
        lead: 'Tên và mô tả chỉ hiển thị trong CRM — bản thân trang không thay đổi.',
        name: 'Tên',
        nameHint: 'Để trống sẽ dùng tên trong sổ đăng ký: «{registry}»',
        description: 'Mô tả',
        descriptionPlaceholder: 'Trang phục vụ chiến dịch nào và cần lưu ý gì',
        tooLong: 'Không dài quá {max} ký tự',
      },
      card: {
        tabs: {
          overview: 'Tổng quan',
          seo: 'SEO',
        },
        openPage: 'Mở trang',
        publication: 'Xuất bản',
        state: 'Trạng thái',
        publishedOn: 'Đã xuất bản ngày {date}',
        canonical: 'Địa chỉ chuẩn',
        seoHint:
          'Thẻ «SEO» đặt thẻ meta và địa chỉ chuẩn — chúng sẽ đi cùng lần xuất bản tiếp theo.',
        indexing: {
          openInSitemap: 'Mở, có trong sitemap',
          openNoSitemap: 'Mở, ngoài sitemap',
          closed: 'Đóng với tìm kiếm',
        },
        traffic: '{days} ngày qua ({range})',
        events: 'Hoạt động trên trang trong cùng kỳ',
        noViews:
          'Không có lượt xem trong kỳ — không có gì để chia. ' +
          'Yêu cầu đến từ biểu mẫu, lượt xem từ beacon của trang: có vẻ beacon chưa được cài.',
        leadsExceedViews:
          'Số yêu cầu nhiều hơn lượt xem: một phần lượt truy cập chưa được beacon ghi nhận.',
        openAnalytics: 'Diễn biến và nguồn của trang này →',
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        conversion: 'Chuyển đổi',
        trafficHint: 'Tính theo slug của trang: trang gửi lượt xem, biểu mẫu trên đó gửi yêu cầu.',
        campaigns: 'Chiến dịch tới trang này (toàn thời gian)',
        campaignsEmpty: 'Chưa có chiến dịch nào dẫn tới đây.',
        notFound: 'Không tìm thấy trang đích',
      },
      actions: {
        publish: 'Xuất bản',
        unpublish: 'Gỡ xuất bản',
        open: 'Mở',
        refresh: 'Làm mới',
      },
      external: {
        title: 'Việc xuất bản và SEO do chủ tên miền quyết định',
        description:
          'Trang do pipeline của chủ đầu tư dựng và triển khai, nên ở đây không có nút «Xuất bản» và thẻ SEO — nếu không, chúng ta sẽ đăng nội dung của người khác tại vinprop.vn. Lượt xem và yêu cầu vẫn được tính như trang của mình: trên trang có beacon của chúng ta với slug {slug}.',
      },
      seo: {
        indexing: {
          title: 'Lập chỉ mục',
          toggle: 'Mở cho công cụ tìm kiếm',
          on: 'Bật: trang mở cho tìm kiếm — meta robots = index, follow. Trang đích nằm trên tên miền chính và không có robots.txt riêng: tệp chung của tên miền không bị thay đổi.',
          off: 'Tắt: trang vẫn truy cập được, nhưng meta robots = noindex, nofollow loại nó khỏi kết quả. Trang đích nằm trên tên miền chính và không có robots.txt riêng: tệp chung của tên miền không bị thay đổi.',
          sitemap: 'Thêm vào sitemap.xml của trang chính',
          sitemapHint:
            'Chỉ dành cho trang đã mở: trang đóng mà nằm trong sơ đồ trang là mâu thuẫn và Search Console sẽ cảnh báo.',
        },
        meta: {
          title: 'Thẻ meta',
          seoTitle: 'Tiêu đề trang (title)',
          seoDescription: 'Mô tả (description)',
          titleCounter: '{count} trên 60 ký tự — hiển thị đầy đủ trong kết quả',
          titleCounterOver: '{count} ký tự — kết quả sẽ cắt ở khoảng 60',
          descriptionCounter: '{count} trên 160 ký tự — công cụ tìm kiếm hiển thị khoảng 160',
          canonical: 'Địa chỉ chuẩn',
          canonicalSelf: 'Địa chỉ của trang — {url}',
          canonicalExternal: 'Trang khác — nhập địa chỉ',
          canonicalUrl: 'Địa chỉ trang chuẩn',
          canonicalUrlError: 'Cần địa chỉ đầy đủ dạng https://…',
          canonicalHint:
            'Nếu cùng dự án đã có trên trang chính, chỉ một trang được chọn làm chuẩn — nếu không chúng chia nhau cùng một truy vấn.',
          image: 'Ảnh cho tin nhắn và mạng xã hội',
          imageHint: '1200 × 630, JPG hoặc PNG — Telegram, WhatsApp và Facebook sẽ hiển thị',
          imageUpload: 'Tải lên',
          imageReplace: 'Thay ảnh',
          imageError: 'Không tải được ảnh',
        },
        output: {
          title: 'Nội dung sẽ lên production',
          sitemapFile: 'sitemap.xml của trang chính',
          sitemapIn: 'địa chỉ được đưa vào',
          sitemapOut: 'địa chỉ bị loại — trang đóng với tìm kiếm',
          hint: 'Thẻ được áp dụng khi xuất bản từ cài đặt ở trên — không sửa tay trong mã nguồn, nếu không cài đặt và production sẽ lệch nhau.',
        },
        preview: {
          title: 'Tìm kiếm sẽ hiển thị thế nào',
          fallbackTitle: 'Tiêu đề lấy từ mã nguồn trang',
          fallbackDescription: 'Mô tả lấy từ mã nguồn trang',
          hint: 'Công cụ tìm kiếm có thể hiển thị văn bản riêng, nhưng lấy từ các trường này.',
        },
        checks: {
          title: 'Kiểm tra',
          titleOk: 'Tiêu đề {count} ký tự — hiển thị đầy đủ',
          titleLong: 'Tiêu đề {count} ký tự — sẽ bị cắt',
          titleEmpty: 'Chưa đặt tiêu đề — nội dung trong mã nguồn sẽ lên production',
          descriptionOk: 'Mô tả {count} ký tự',
          descriptionLong: 'Mô tả {count} ký tự — công cụ tìm kiếm hiển thị khoảng 160',
          descriptionEmpty: 'Chưa đặt mô tả — nội dung trong mã nguồn sẽ lên production',
          complexCompeting: 'Cùng dự án đã mở trên trang chính: {url}. Hãy chọn trang nào là chuẩn',
          complexAction: 'Chọn trang dự án làm chuẩn',
          canonicalInvalid: 'Địa chỉ chuẩn chưa đầy đủ: cần địa chỉ https://',
          closed: 'Trang đóng với tìm kiếm — cài đặt vẫn lưu, nhưng trang sẽ không vào kết quả',
        },
        footer: 'Cài đặt được áp dụng ở lần xuất bản tiếp theo.',
        save: 'Lưu',
        cancel: 'Huỷ',
      },
      publishModal: {
        publishTitle: 'Xuất bản trang đích',
        unpublishTitle: 'Gỡ xuất bản',
        publishConfirm: 'Xuất bản',
        unpublishConfirm: 'Gỡ',
        cancel: 'Huỷ',
        willDeploy: 'Nội dung sẽ lên production',
        robots: 'Thẻ robots',
        canonical: 'Địa chỉ chuẩn',
        sitemap: 'Sơ đồ trang',
        sitemapIn: 'địa chỉ sẽ vào sitemap.xml chung',
        sitemapOut: 'địa chỉ bị loại — trang đóng với tìm kiếm',
        robotsFileNote:
          'robots.txt dùng chung cho tên miền và không thay đổi ở đây: thẻ meta quyết định lập chỉ mục.',
        closedWarning:
          'Trang đóng với tìm kiếm: vẫn truy cập được theo địa chỉ, nhưng thẻ meta loại nó khỏi kết quả.',
        seoEmptyWarning: 'Chưa đặt tiêu đề và mô tả — nội dung trong mã nguồn sẽ lên production.',
        unpublishWarning: 'Tệp sẽ bị xoá khỏi kho lưu trữ, địa chỉ bắt đầu trả về 404.',
      },
    },
  },
}
